// Misc
import React, { Children } from 'react'
import { SortableContainer } from 'react-sortable-hoc'
import { isTouchSupported } from 'utils/device'

const Container = SortableContainer(({ children }) => (
  Children.only(children)
))

export default (ownProps) => {
  const props = isTouchSupported() ? {
    pressDelay: 300,
    pressThreshold: 0
  } : {
    distance: 10
  }
  return (
    <Container
      {...props}
      {...ownProps}
    />
  )
}
